import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    time: 0,
    comment: '',
    scramble: '', // Scramble not yet generated
    scrambleId: '', // Scramble not yet generated
    lastSolveData: {}, // previous solve data used for updating solve metadata
    solver: '',
    solverId: '',
    sessionId: '',
    sessionType: '',
    authToken: '', // session auth token
    globalAuthToken: '', // User not logged in
    socket: null,
    sessionTimesSettings: {},

    // TPC related
    eventName: '',
    loginSettings: {},
  },
  mutations: {
    setSessionId (state, sessionId) {
      state.sessionId = sessionId
    },

    setSessionType (state, sessionType) {
      state.sessionType = sessionType
    },

    setTime (state, time) {
      state.time = time
    },
    setComment (state, comment) {
      state.comment = comment
    },
    setLastSolveData (state, lastSolveData) {
      state.lastSolveData = lastSolveData
    },

    setSolver (state, solver) {
      state.solver = solver
    },

    setScramble (state, scramble) {
      state.scramble = scramble
    },

    setSolverId (state, solverId) {
      state.solverId = solverId
    },

    setScrambleId (state, scrambleId) {
      state.scrambleId = scrambleId
    },

    setAuthToken (state, authToken) {
      state.authToken = authToken
    },

    setGlobalAuthToken (state, globalAuthToken) {
      state.globalAuthToken = globalAuthToken
    },

    setSessionTimesSettings (state, sessionTimesSettings) {
      state.sessionTimesSettings = sessionTimesSettings
    },

    // TPC related
    setEventName (state, eventName) {
      state.eventName = eventName
    },
    setLoginSettings (state, loginSettings) {
      state.loginSettings = loginSettings
    },
  }
})
